/* eslint-disable eqeqeq */
import { takeLatest, select, put, call } from 'redux-saga/effects';
// import { useSnackbar } from 'notistack';
import * as authActions from '../actions/authActions';
// import * as LoaderAction from '../actions/loaderAction';
import * as SnackbarAction from '../actions/snackbarAction';
import cookieLib from '../helpers/cookieLib';
import history from '../utils/history';
import { callApi } from '../utils/api';
import URLS from '../constants/urls';
import { setLoader } from '../actions/loaderAction';
import ForgeLib from '../helpers/forgeLib';
import Locales from '../constants/locales';
const SnackbarConstants = Locales.JSON.snackbar;

export function* fetchCountryCodes() {
  try {
    const response = yield call(callApi, URLS.COUNTRYCODE_TYPEAHEAD, 'GET');
    yield put(authActions.countryCodesReceived(response.res_data || []));
  } catch (error) {
    //   console.log(error)
  }
}

export function* checkInviteStatus(action) {
  const inviteToken = action.token;
  const params = action.query;
  try {
    const inviteResponse = yield call(
      callApi,
      URLS.INVITE_STATUS,
      'GET',
      params,
    );
    const inviteData = {
      ...inviteResponse.res_data.data,
      status: inviteResponse.res_data.status,
    };

    yield put(authActions.inviteStatusChecked(inviteData));
  } catch (error) {
    // console.log(error);
    /* yield put(authActions.inviteStatusChecked({
      email_id : 'nitishhardeniya@gmail.com',
      invite_id: 'happayakatoken',
    })); */
    const inviteData = {
      ...error.data.res_data.data,
      status: error.data.res_data.status,
    };
    yield put(authActions.inviteStatusChecked(inviteData));
  }
}

export function* submitSignup(action) {
  try {
    const signupResponse = yield call(
      callApi,
      URLS.SIGNUP,
      'POST',
      action.payload,
    );
    yield put(setLoader(false));
    if (window.localStorage.getItem('hasLogin')) {
      window.localStorage.removeItem('hasLogin');
    }
    yield put(authActions.signupSuccess(signupResponse.res_data));
  } catch (error) {
    yield put(setLoader(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* fetchAuthMode(action) {
  try {
    const response = yield call(
      callApi,
      URLS.FETCH_AUTH,
      'GET',
      action.payload,
    );
    const data = response.res_data;
    if (data.status == 0) {
      let keyData = {};
      if (data.public_key) {
        keyData = {
          public_key: data.public_key,
          token_id: data.token_id,
        };
      }
      yield put(authActions.setauthmode(keyData));
      const pageName = '/login/passwordpage';
      history.push(pageName);
    }
    // else if (data.status == 1) {
    //     const pageName = "/login/signinwithotp";
    //     history.push(pageName);
    // }
  } catch (error) {
    //   console.log(error)
  }
}

export function* submitLogin(action) {
  const encryptionKey = action.authData;
  const { payload } = action;
  if (encryptionKey && encryptionKey.public_key) {
    payload.password = ForgeLib.encryptData(
      encryptionKey.public_key,
      payload.password,
    );
    payload.token_id = encryptionKey.token_id;
  } else {
    payload.token_id = undefined;
  }
  try {
    const loginResponse = yield call(callApi, URLS.LOGIN, 'POST', payload);
    const {
      res_data: data = {},
      res_code: code,
      res_str: str = '',
    } = loginResponse;

    if (data.status == 0) {
      // Set cookies from here
      cookieLib.setCookieByKey('has_role', data.details.has_role);
      const [hostname] = window.location.hostname?.split('.');
      cookieLib.setCookieByKey('root-product', hostname || 'payment');
      if (payload.password || payload.otp) {
        history.push('/dashboard');
      }
    } else if (data.status == 1) {
      if (data?.profiles?.length && (payload.password || !payload.user_id)) {
        yield put(authActions.multiprofiles(data.profiles));
        let keyData = {};
        if (data.public_key) {
          keyData = {
            public_key: data.public_key,
            token_id: data.token_id,
          };
        }
        yield put(authActions.setauthmode(keyData));
        history.push('/login/multiprofiles');
      }
    }
    yield put(setLoader(false));
  } catch (error) {
    if (error.data.res_code == '899') {
      history.push('/login/alreadyLoggedIn');
      yield put(
        authActions.setLoginErrorData({
          str: error.data?.res_str,
          token: error?.data?.res_data?.temporary_token,
        }),
      );
    } else {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
    yield put(setLoader(false, error));
  }
}

export function* generateOTP(action) {
  try {
    const otpResponse = yield call(
      callApi,
      URLS.SEND_OTP,
      'POST',
      action.payload,
    );
    yield put(authActions.otpSent(otpResponse.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: SnackbarConstants.OTP_SENT,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* resetWithOTP(action) {
  const inviteToken = action.token;
  const params = action.query;
  try {
    const otpResponse = yield call(callApi, URLS.GENERATE_OTP, 'GET', params);
    yield put(authActions.resetOTPSent(otpResponse.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: SnackbarConstants.OTP_SENT,
        type: 'success',
      }),
    );
  } catch (error) {
    // console.log(`API failed - reset OTP`);
  }
}

export function* mncResetWithOTP(action) {
  const params = action.payload;
  try {
    const otpResponse = yield call(callApi, URLS.GENERATE_OTP, 'GET', params);
    yield put(authActions.mncResetOTPSent(true));
    yield put(
      SnackbarAction.openSnackbar({
        message: SnackbarConstants.OTP_SENT,
        type: 'success',
      }),
    );
  } catch (error) {
    // console.log(`API failed - reset OTP`);
  }
}

export function* resetPassword(action) {
  try {
    const resetResponse = yield call(
      callApi,
      URLS.SET_PASSWORD,
      'POST',
      action.payload,
    );
    yield put(authActions.resetPasswordSuccess(resetResponse.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: resetResponse.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* resetMobileNo(action) {
  try {
    const resetResponse = yield call(
      callApi,
      URLS.EDITUSERMOBILENO,
      'POST',
      action.payload,
    );
    const data = {
      res_str: (resetResponse.res_data && resetResponse.res_data.res_str) || '',
      success: true,
    };
    yield put(authActions.resetMobileNoSuccess(data));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: resetResponse.res_str,
    //     type: 'success',
    //   }),
    // );
  } catch (error) {
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: error.data.res_str,
    //     type: 'error',
    //   }),
    // );
    const data = {
      res_str: error.data.res_str || '',
      success: false,
    };
    yield put(authActions.resetMobileNoSuccess(data));
  }
}

export function* editName(action) {
  try {
    const resetResponse = yield call(
      callApi,
      URLS.EDITNAME,
      'POST',
      action.payload,
      false,
      'N',
    );
    yield put(setLoader(false));
    yield put(authActions.nameEditSuccess(true));
  } catch (error) {
    yield put(setLoader(false));
    yield put(authActions.nameEditSuccess(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* checkSSO(action) {
  try {
    const resetResponse = yield call(
      callApi,
      URLS.SSO_CHECK,
      'GET',
      action.payload,
    );
    yield put(setLoader(false));
    window.location = resetResponse.redirect_url;
  } catch (error) {
    yield put(setLoader(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* sesisonResendOTP(action) {
  try {
    const data = yield call(
      callApi,
      URLS.SESSION_LOGIN_OTP,
      'POST',
      action.payload,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: data.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* sesisonVerifyOTP(action) {
  try {
    yield call(callApi, URLS.SESSION_VERIFY_OTP, 'POST', action.payload);
    yield put(setLoader(false));
    history.push('/login');
  } catch (error) {
    yield put(setLoader(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* authSaga() {
  yield takeLatest('GET_COUNTRY_CODES', fetchCountryCodes);
  yield takeLatest('INVITE_STATUS', checkInviteStatus);
  yield takeLatest('POST_SIGNUP', submitSignup);
  yield takeLatest('GET_FETCH_MODE', fetchAuthMode);
  yield takeLatest('POST_LOGIN', submitLogin);
  yield takeLatest('GENERATE_OTP', generateOTP);
  yield takeLatest('CHECK_SSO', checkSSO);
  yield takeLatest('RESET_WITH_OTP', resetWithOTP);
  yield takeLatest('MNC_RESET_OTP_SENT', mncResetWithOTP);
  yield takeLatest('POST_RESET_PASSWORD', resetPassword);
  yield takeLatest('EDIT_MOBILE_NO', resetMobileNo);
  yield takeLatest('EDIT_NAME', editName);
  yield takeLatest('SESSION_LOGIN_OTP', sesisonResendOTP);
  yield takeLatest('SESSION_VERIFY_OTP', sesisonVerifyOTP);
}
